(function () {
    // Находим все контейнеры фильтров и элемент header__car
    const filterContainers = document.querySelectorAll('.filter-container-json');
    const headerCar = document.querySelector('.header__car--desktop');
    const headerCarBrand = headerCar.querySelector('.header__car_info_brand');
    const headerCarModel = headerCar.querySelector('.header__car_info_model');
    const headerCarYear = headerCar.querySelector('.header__car_info_year');


    if (!filterContainers.length || !headerCar || !headerCarBrand || !headerCarModel || !headerCarYear) {
        console.warn('Required elements not found:', { filterContainers, headerCar, headerCarBrand, headerCarModel, headerCarYear });
        return;
    }

    // Обновляем header__car на основе данных из localStorage
    function updateHeaderCar() {
        const saved = localStorage.getItem('carFilterSelections');
        if (!saved) {
            headerCarBrand.textContent = '';
            headerCarModel.textContent = '';
            headerCarYear.textContent = '';
            headerCar.classList.remove('active');
            return;
        }

        try {
            const { brand, model, years } = JSON.parse(saved);
            headerCarBrand.textContent = (brand || '').trim();
            headerCarModel.textContent = (model || '').trim();
            headerCarYear.textContent = (years || '').trim();
            // Добавляем класс active, если есть хотя бы одно непустое значение
            const hasData = !!(brand || model || years);
            headerCar.classList.toggle('active', hasData);
        } catch (error) {
            console.error('Error parsing localStorage for header__car:', error);
            headerCarBrand.textContent = '';
            headerCarModel.textContent = '';
            headerCarYear.textContent = '';
            headerCar.classList.remove('active');
        }
    }

    // Вызываем при загрузке страницы (только localStorage, без fetch)
    updateHeaderCar();

    // Отложенная загрузка JSON — только при первом открытии селектора
    var jsonLoaded = false;
    var jsonLoadPromise = null;
    var ensureJsonLoaded = function () { return Promise.resolve(); };

    const initWithDataFns = [];

    // Обрабатываем каждый контейнер фильтра
    filterContainers.forEach((container, index) => {
        // Находим элементы внутри текущего контейнера
        const brandCustomSelect = container.querySelector('.brand-custom-select');
        const brandSelectOptions = container.querySelector('.brand-select-options');
        const modelCustomSelect = container.querySelector('.model-custom-select');
        const modelSelectOptions = container.querySelector('.model-select-options');
        const yearsCustomSelect = container.querySelector('.years-custom-select');
        const yearsSelectOptions = container.querySelector('.years-select-options');
        const clearFilters = container.querySelector('.clear-filters');
        const searchButton = container.querySelector('.search-button-json');
        const brandInput = container.querySelector('.brand-input');
        const modelInput = container.querySelector('.model-input');
        const yearsInput = container.querySelector('.years-input');
        const selectItemsAll = () => container.querySelectorAll('.select-items');

        let localJson;

        // Инициализация контейнера после загрузки JSON (вызовется один раз общим fetch)
        initWithDataFns.push((data) => {
            localJson = data;
            populateBrandDropdown(localJson);
            restoreSelectionsFromLocalStorage().then(() => updateHeaderCar());
        });

        function sortLocale(a, b) {
            return String(a).trim().localeCompare(String(b).trim(), undefined, { sensitivity: 'base', numeric: true });
        }

        function jsonBrandKey(trimmedLabel) {
            const t = (trimmedLabel || '').trim();
            if (!t || !localJson) return '';
            return Object.keys(localJson).find(function (k) { return k.trim() === t; }) || '';
        }

        function populateBrandDropdown(data) {
            brandSelectOptions.innerHTML = '';
            Object.keys(data).sort(sortLocale).forEach(brand => {
                const div = document.createElement('div');
                div.textContent = brand.trim();
                div.dataset.brand = brand;
                brandSelectOptions.appendChild(div);
            });
        }

        function populateModelDropdown(models) {
            modelSelectOptions.innerHTML = '';
            models.slice().sort((a, b) => sortLocale(a.name || '', b.name || '')).forEach(model => {
                const div = document.createElement('div');
                div.textContent = (model.name || '').trim();
                div.dataset.url = (model.url || '').trim();
                modelSelectOptions.appendChild(div);
            });
        }

        async function fetchAndPopulateFilters(collectionUrl) {
            let allProducts = [];
            let totalPages = 1;

            const fetchPage = async (page) => {
                const url = `${collectionUrl}?page=${page}&view=json`;
                const response = await fetch(url);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                return data;
            };

            try {
                const firstPageData = await fetchPage(1);
                allProducts = allProducts.concat(firstPageData.products);
                const perPage = firstPageData.products.length;
                totalPages = perPage > 0 ? Math.ceil(firstPageData.total_products / perPage) : 1;

                if (totalPages > 1) {
                    const restPages = await Promise.all(
                        Array.from({ length: totalPages - 1 }, (_, i) => fetchPage(i + 2))
                    );
                    restPages.forEach((data) => allProducts.push(...data.products));
                }

                let years = new Set();
                allProducts.forEach(product => {
                    if (product.years != null && String(product.years).trim() !== '') {
                        years.add(String(product.years).trim());
                    }
                });

                populateYearsDropdown([...years]);

                // Восстанавливаем год после заполнения списка
                const saved = localStorage.getItem('carFilterSelections');
                if (saved) {
                    const { years: savedYears } = JSON.parse(saved);
                    if (savedYears) {
                        const yearDiv = Array.from(yearsSelectOptions.children).find(div => div.textContent.trim() === (savedYears || '').trim());
                        if (yearDiv) {
                            selectOption(yearDiv, yearsCustomSelect, yearsSelectOptions, false);
                        } else {
                            console.warn(`Saved year "${savedYears}" not found in available years:`, [...years]);
                            yearsCustomSelect.querySelector('.select-selected').value = '';
                            yearsCustomSelect.classList.remove('selected');
                        }
                    }
                    updateHeaderCar(); // Обновляем после попытки восстановления years
                }
            } catch (error) {
                console.error('Error fetching collection products:', error);
            }
        }

        function populateYearsDropdown(years) {
            yearsSelectOptions.innerHTML = '';
            years.sort(sortLocale).forEach(year => {
                const div = document.createElement('div');
                div.textContent = String(year).trim();
                yearsSelectOptions.appendChild(div);
            });
        }

        function selectOption(element, selectWrapper, selectOptions, saveToLocalStorage) {
            const selected = selectWrapper.querySelector('.select-selected');
            selected.value = (element.textContent || '').trim();
            selected.dataset.url = (element.dataset.url || '').trim();
            selectOptions.classList.add('select-hide');
            selectWrapper.classList.add('selected');
            checkIfSearchEnabled();
            closeAllSelects();
            if (saveToLocalStorage) {
                saveSelectionsToLocalStorage();
            }
        }

        function buildUrl() {
            const brandVal = (brandCustomSelect.querySelector('.select-selected').value || '').trim();
            const modelElement = modelCustomSelect.querySelector('.select-selected');
            const modelVal = (modelElement.value || '').trim();
            const modelUrl = modelElement.dataset.url || '';
            const years = (yearsCustomSelect.querySelector('.select-selected').value || '').trim();
            const urlParams = new URLSearchParams();
            if (years) {
                urlParams.set('filter.p.m.custom.filter_years', years);
            }
            const queryString = urlParams.toString();
            const qs = queryString ? '?' + queryString : '';
            if (modelVal && modelUrl) {
                return modelUrl + qs;
            }
            if (brandVal) {
                var slug = brandVal.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                return (window.location.origin || '') + '/collections/' + slug + qs;
            }
            return window.location.href;
        }

        function resetModelSelect() {
            const sel = modelCustomSelect.querySelector('.select-selected');
            sel.value = '';
            delete sel.dataset.url;
            modelSelectOptions.innerHTML = '';
            modelCustomSelect.classList.remove('selected');
        }

        function resetYearsSelect() {
            const sel = yearsCustomSelect.querySelector('.select-selected');
            sel.value = '';
            yearsCustomSelect.classList.remove('selected');
        }

        function clearBrandAndSave() {
            brandCustomSelect.querySelector('.select-selected').value = '';
            brandCustomSelect.classList.remove('selected');
            resetModelSelect();
            resetYearsSelect();
            saveSelectionsToLocalStorage();
            updateHeaderCar();
            checkIfSearchEnabled();
        }

        function clearModelAndSave() {
            var brandVal = (brandCustomSelect.querySelector('.select-selected').value || '').trim();
            resetModelSelect();
            resetYearsSelect();
            var brandKey = jsonBrandKey(brandVal);
            if (brandKey && localJson && Array.isArray(localJson[brandKey].models)) {
                populateModelDropdown(localJson[brandKey].models);
                enableModelSelect();
            }
            saveSelectionsToLocalStorage();
            updateHeaderCar();
            checkIfSearchEnabled();
        }

        function clearYearsAndSave() {
            resetYearsSelect();
            saveSelectionsToLocalStorage();
            updateHeaderCar();
            checkIfSearchEnabled();
        }

        function enableModelSelect() {
            const modelInput = modelCustomSelect.querySelector('.select-selected');
            modelInput.classList.remove('disabled');
            modelInput.removeAttribute('disabled');
        }

        function enableFilters() {
            const yearsInput = yearsCustomSelect.querySelector('.select-selected');
            yearsInput.classList.remove('disabled');
            yearsInput.removeAttribute('disabled');
        }

        function closeAllSelects() {
            selectItemsAll().forEach(item => item.classList.add('select-hide'));
        }

        function toggleSelectOptions(selectOptions) {
            selectOptions.classList.toggle('select-hide');
        }

        // Делегирование: один обработчик на контейнер опций вместо сотен на каждый div
        brandSelectOptions.addEventListener('click', (e) => {
            const div = e.target.closest('div:not(.not-found-message)');
            if (!div || div.parentElement !== brandSelectOptions || !div.dataset.brand) return;
            const brand = div.dataset.brand;
            selectOption(div, brandCustomSelect, brandSelectOptions, true);
            resetModelSelect();
            enableModelSelect();
            if (localJson[brand] && Array.isArray(localJson[brand].models)) {
                requestAnimationFrame(() => populateModelDropdown(localJson[brand].models));
            }
        });
        modelSelectOptions.addEventListener('click', (e) => {
            const div = e.target.closest('div:not(.not-found-message)');
            if (!div || div.parentElement !== modelSelectOptions || !div.dataset.url) return;
            const url = div.dataset.url;
            selectOption(div, modelCustomSelect, modelSelectOptions, true);
            enableFilters();
            requestAnimationFrame(() => fetchAndPopulateFilters(url));
        });
        yearsSelectOptions.addEventListener('click', (e) => {
            const div = e.target.closest('div:not(.not-found-message)');
            if (!div || div.parentElement !== yearsSelectOptions) return;
            selectOption(div, yearsCustomSelect, yearsSelectOptions, true);
        });

        brandInput.addEventListener('click', function () {
            if (!jsonLoaded) {
                brandSelectOptions.innerHTML = '<div class="select-loading" style="padding:10px;color:#666;text-align:center;">Ładowanie...</div>';
                ensureJsonLoaded();
                toggleSelectOptions(brandSelectOptions);
            } else {
                toggleSelectOptions(brandSelectOptions);
            }
        });
        modelInput.addEventListener('click', () => toggleSelectOptions(modelSelectOptions));
        yearsInput.addEventListener('click', () => toggleSelectOptions(yearsSelectOptions));

        container.addEventListener('click', (event) => {
            if (!event.target.closest('.custom-select-wrapper')) {
                closeAllSelects();
            }
        });

        document.addEventListener('click', function (event) {
            if (!container.contains(event.target)) {
                closeAllSelects();
            }
        });

        clearFilters.addEventListener('click', () => {
            brandCustomSelect.querySelector('.select-selected').value = '';
            modelCustomSelect.querySelector('.select-selected').value = '';
            yearsCustomSelect.querySelector('.select-selected').value = '';
            localStorage.removeItem('carFilterSelections');
            closeAllSelects();
            checkIfSearchEnabled();
            updateHeaderCar(); // Обновляем header__car после очистки
        });

        searchButton.addEventListener('click', () => {
            const url = buildUrl();
            window.location.href = url;
        });

        function checkIfSearchEnabled() {
            const selectedBrand = (brandCustomSelect.querySelector('.select-selected').value || '').trim();
            searchButton.disabled = !selectedBrand;
        }

        function scheduleFilter(inputEl, optionsContainer) {
            if (inputEl._filterScheduled) return;
            inputEl._filterScheduled = true;
            requestAnimationFrame(() => {
                inputEl._filterScheduled = false;
                filterSelectOptions(inputEl, optionsContainer);
            });
        }
        brandInput.addEventListener('input', function () {
            if ((brandInput.value || '').trim() === '') clearBrandAndSave();
            scheduleFilter(brandInput, brandSelectOptions);
        });
        modelInput.addEventListener('input', function () {
            if ((modelInput.value || '').trim() === '') clearModelAndSave();
            scheduleFilter(modelInput, modelSelectOptions);
        });
        yearsInput.addEventListener('input', function () {
            if ((yearsInput.value || '').trim() === '') clearYearsAndSave();
            scheduleFilter(yearsInput, yearsSelectOptions);
        });

        function showNotFoundMessage(optionsContainer) {
            // Проверяем, есть ли уже сообщение
            if (optionsContainer.querySelector('.not-found-message')) {
                return;
            }
            
            const notFoundDiv = document.createElement('div');
            notFoundDiv.classList.add('not-found-message');
            notFoundDiv.textContent = 'Nie znaleziono';
            notFoundDiv.style.padding = '10px';
            notFoundDiv.style.color = '#999';
            notFoundDiv.style.fontStyle = 'italic';
            notFoundDiv.style.textAlign = 'center';
            notFoundDiv.style.pointerEvents = 'none';
            optionsContainer.appendChild(notFoundDiv);
        }

        function removeNotFoundMessage(optionsContainer) {
            const notFoundDiv = optionsContainer.querySelector('.not-found-message');
            if (notFoundDiv) {
                notFoundDiv.remove();
            }
        }

        function filterSelectOptions(inputEl, optionsContainer) {
            const divs = optionsContainer.getElementsByTagName('div');
            const isYears = optionsContainer === yearsSelectOptions;

            if (isYears) {
                const val = inputEl.value.trim();
                if (!val) {
                    for (let div of divs) {
                        if (!div.classList.contains('not-found-message')) {
                            div.style.display = '';
                        }
                    }
                    removeNotFoundMessage(optionsContainer);
                    return;
                }
                const year = parseInt(val, 10);
                let hasVisibleItems = false;
                
                if (isNaN(year)) {
                    for (let div of divs) {
                        if (!div.classList.contains('not-found-message')) {
                            div.style.display = 'none';
                        }
                    }
                } else {
                    for (let div of divs) {
                        if (div.classList.contains('not-found-message')) {
                            continue;
                        }
                        
                        const txt = div.textContent.trim();
                        const parts = txt.split('-');
                        if (parts.length === 2) {
                            const start = parseInt(parts[0], 10);
                            const end = parseInt(parts[1], 10);
                            if (!isNaN(start) && !isNaN(end) && year >= start && year <= end) {
                                div.style.display = '';
                                hasVisibleItems = true;
                            } else {
                                div.style.display = 'none';
                            }
                        } else {
                            div.style.display = 'none';
                        }
                    }
                }
                
                if (!hasVisibleItems) {
                    showNotFoundMessage(optionsContainer);
                } else {
                    removeNotFoundMessage(optionsContainer);
                }
            } else {
                let filter = inputEl.value.toLowerCase().replace(/s/g, '[sš]');
                let hasVisibleItems = false;
                
                for (let div of divs) {
                    if (div.classList.contains('not-found-message')) {
                        continue;
                    }
                    
                    const txtValue = ((div.textContent || div.innerText) || '').trim();
                    const regex = new RegExp(filter, 'i');
                    if (regex.test(txtValue)) {
                        div.style.display = '';
                        hasVisibleItems = true;
                    } else {
                        div.style.display = 'none';
                    }
                }
                
                if (!hasVisibleItems && inputEl.value.trim() !== '') {
                    showNotFoundMessage(optionsContainer);
                } else {
                    removeNotFoundMessage(optionsContainer);
                }
                
                if (inputEl === brandInput && inputEl.value.trim() === '') {
                    modelInput.setAttribute('disabled', true);
                }
            }
        }

        function saveSelectionsToLocalStorage() {
            const selections = {
                brand: (brandCustomSelect.querySelector('.select-selected').value || '').trim(),
                model: (modelCustomSelect.querySelector('.select-selected').value || '').trim(),
                modelUrl: (modelCustomSelect.querySelector('.select-selected').dataset.url || '').trim(),
                years: (yearsCustomSelect.querySelector('.select-selected').value || '').trim()
            };
            localStorage.setItem('carFilterSelections', JSON.stringify(selections));
            updateHeaderCar(); // Обновляем header__car сразу после записи
        }

        async function restoreSelectionsFromLocalStorage() {
            const saved = localStorage.getItem('carFilterSelections');
            if (!saved) {
                updateHeaderCar();
                return;
            }

            const { brand, model, modelUrl } = JSON.parse(saved);

            if (brand) {
                const brandDiv = Array.from(brandSelectOptions.children).find(div => div.textContent.trim() === (brand || '').trim());
                if (brandDiv) {
                    const brandKey = brandDiv.dataset.brand;
                    selectOption(brandDiv, brandCustomSelect, brandSelectOptions, false);
                    resetModelSelect();
                    if (brandKey && localJson[brandKey] && Array.isArray(localJson[brandKey].models)) {
                        populateModelDropdown(localJson[brandKey].models);
                        enableModelSelect();
                    }
                }
            }

            if (model && modelUrl) {
                const modelDiv = Array.from(modelSelectOptions.children).find(div => div.textContent.trim() === (model || '').trim());
                if (modelDiv) {
                    modelDiv.dataset.url = (modelUrl || '').trim();
                    selectOption(modelDiv, modelCustomSelect, modelSelectOptions, false);
                    enableFilters();
                    await fetchAndPopulateFilters(modelUrl); // Восстановление years происходит здесь
                }
            }
        }
    });

    // Загрузка JSON при первом обращении (клик по марке или по блоку "выбор авто")
    const jsonUrl = filterContainers[0] && filterContainers[0].dataset.json;
    if (jsonUrl && initWithDataFns.length > 0) {
        ensureJsonLoaded = function () {
            if (jsonLoaded) return Promise.resolve();
            if (!jsonLoadPromise) {
                jsonLoadPromise = fetch(jsonUrl)
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                        initWithDataFns.forEach(function (fn) { fn(data); });
                        jsonLoaded = true;
                        return data;
                    })
                    .catch(function (error) {
                        jsonLoadPromise = null;
                        console.error('Error loading JSON:', error);
                    });
            }
            return jsonLoadPromise;
        };
        headerCar.addEventListener('click', function () { ensureJsonLoaded(); });
    }
})();